<template>
  <div
    class="block py-24 sm:py-48 container category-listing-block xxl:px-24"
  >
    <div
      class="pt-48 pb-38 rounded-xl sm:pb-68 sm:pt-80"
      :class="{
        'bg-blue-25': component.backgroundColor === 'blue-theme',
        'bg-orange-full text-white':
          component.backgroundColor === 'brown-theme',
        'bg-green-75 text-white': component.backgroundColor === 'green-theme',
      }"
    >
      <h1 v-if="component.labelAsH1" class="text-center mb-24 md:mb-32">
        {{ component.label }}
      </h1>
      <h2 v-else class="text-center mb-24">{{ component.label }}</h2>
      <div class="mx-auto lg:w-3/4 md:px-32 flex justify-center flex-wrap">
        <div v-for="link in component.links" :key="link.id">
          <nuxt-link
            v-if="link.link"
            :to="link.link.url"
            :target="link.link.target"
            class="btn btn--lg mx-6 mb-12"
            :class="{
              'btn--primary': component.backgroundColor === 'blue-theme',
              'btn--secondary btn--ghost':
                component.backgroundColor === 'green-theme' ||
                component.backgroundColor === 'brown-theme',
            }"
          >
            {{ link.link.title }}
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ComponentBlock from '~/models/component-block';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
  },
});
</script>
<style scoped>
.dynamic-promo-grid + .category-listing-block {
  @apply pt-0;
}
</style>
